import './page/synonym-api-list';

Shopware.Module.register('topdata-es-synonym-api', {
    type: 'plugin',
    name: 'Synonym API',
    title: 'TopdataEnhancedSearchSW6.topdata-es-synonym-api.title',
    description: 'TopdataEnhancedSearchSW6.topdata-es-synonym-api.description',
    color: '#189eff',
    icon: 'default-shopping-search',

    routes: {
        list: {
            component: 'topdata-es-synonym-api-list',
            path: 'list',
            meta: {
                privilege: 'system.zero_search.viewer',
            },
        },
    },

    navigation: [{
        id: 'topdata-es-synonym-api-list',
        label: 'TopdataEnhancedSearchSW6.topdata-es-synonym-api.listTitle',
        color: '#189eff',
        path: 'topdata.es.synonym.api.list',
        parent: 'topdata-es',
    }],
});